import { DateUtil, TIME } from './dateUtil'

const RANGE_DAYS = 7

export const isStartDateInRange = (date) => {
  if (!date) {
    return false
  }

  const diff = date.diff(DateUtil.tz(date.getTz()), TIME.DAYS)

  return diff < RANGE_DAYS && diff >= 0
}

export const isEndDateInRange = (date) => {
  if (!date) {
    return false
  }

  const diff = date.diff(DateUtil.tz(date.getTz()), TIME.DAYS)
  return diff >= 0
}
